module.exports = __webpack_public_path__ + "img/whatsapp.e5296e1c.png";